module.exports = __webpack_public_path__ + "img/GN.d5ae0b43.png";